export function countWords(value: string): number {
  if (!value) return 0;
  return value.trim().split(/\s+/).filter(Boolean).length;
}
